import { useEffect, useState } from "react";
import Payment from "../../../assets/payment_cards.png";
import { pricingData } from "../constant/data";
import madeUsa from "../../../assets/made-in-usa.png";
import FdaImg from "../../../assets/fda.png";
import NoOfferImg from "../../../assets/no-thanks-offer.png";
import ContactDark from "../../../assets/chat-icon-blue.png";
import button from "../../../assets/button.svg";

function PricingCard({ plan, isMiddle, isThird, isVsl = false , vid}) {
    const SECONDS_TO_DISPLAY = 10;

    return (
        // <div className={`relative bg-[#F7F6F4] rounded-lg shadow-lg ${isMiddle ? 'md:-mt-10' : ''} ${isThird ? 'md:-mt-6' : ''}`}>
        <div
            className={`relative bg-[#F7F6F4] rounded-lg shadow-lg h-fit
            ${isMiddle ? "order-1 lg:order-none lg:-mt-6" : ""}
            ${isThird ? "order-2 lg:order-none lg:mt-0" : ""}
            ${!isMiddle && !isThird ? "order-3 lg:order-none lg:mt-0" : ""}
        `}
        >
            {/* Best Value Badge */}
            {plan.bestValue && (
                <div className="relative">
                    <div className="ribbon">
                        <p>
                            <span>BEST</span>
                            <span>VALUE</span>
                        </p>
                    </div>
                </div>
            )}

            {/* Header */}

            <div
                className={`text-center rounded-t-lg space-y-3 pt-7 pb-4 ${plan.bestValue
                    ? "bg-gradient-to-b from-[rgba(244,224,169,0)] via-[#eccc75] to-[#ebbf4f]"
                    : "bg-[#85ade1]"
                    }`}
            >
                <h3 className="text-[48px] fon leading-none  text-[#132c4d] uppercase font-black ">
                    {plan.title}
                    <br />
                </h3>

                <p className="text-[30px] font-semibold text-black leading-[45px]">
                    {plan.subtitle}
                </p>
            </div>

            {/* Content */}
            <div
                className={`space-y-1 relative rounded-md ${plan.bestValue ? "bg-[#F7F6F4] px-6 pt-10 " : "bg-[#F7F6F4] px-6 pt-8"
                    }`}
            >
                {plan.bestValue && (
                    <div className="relative pb-5">
                        {/* Ribbon */}
                        <div className="ribbon2">
                            <p className="text-[20px] font-light leading-[24px]">
                                For Today Only Save <span className="font-bold">EXTRA $15</span>{" "}
                                On This Special Package
                            </p>
                        </div>
                    </div>
                )}
                {/* <img
                    src={plan.product}
                    alt={`${plan.title} Package`}
                    className={`${plan.popular
                        ? 'lg:w-80 w-full  mt-14'
                        : plan.leastpopular
                            ? 'lg:w-64 w-full mt-7 h-auto'
                            : 'w-full h-auto mt-4'
                        }  mx-auto hover:opacity-90 ease-in-out duration-300 transition   `}
                /> */}

                <div>
                    <img
                        src={plan.product}
                        alt={`${plan.title} Package`}
                        className={`${plan.popular
                            ? "lg:w-96 mt-4 w-full h-auto"
                            : plan.leastpopular
                                ? "lg:w-80 w-full h-auto"
                                : "lg:w-80 w-full h-auto"
                            }  mx-auto hover:opacity-90 ease-in-out duration-300 transition   `}
                    />
                </div>

                {/* Pricing */}
                <div className="text-center space-y-4">
                    <div className="flex items-baseline justify-center gap-1">
                        <span className="text-[55px] font-black">
                            ${plan.pricePerBottle}
                        </span>
                        <span className="text-gray-800 font-semibold text-2xl">
                            /bottle
                        </span>
                    </div>
                    {/* Features */}

                    <div className="space-y-1">
                        {plan.shippingfee && (
                            <div className="p-4 py-2  text-[#281c1780]">
                                <p className="lg:text-xl xl:text-2xl text-xl font-bold uppercase">
                                    {plan.shippingfee}
                                </p>
                            </div>
                        )}
                        {plan.youSave && (
                            <div className="px-4 py-2 rounded-md text-lg font-bold shadow-lg flex items-center justify-start gap-2 bg-[#204058] text-white">
                                <img
                                    src="https://sinoclear.net/pm/images/check-mark@2x.webp"
                                    className="h-8 w-8"
                                />
                                <p
                                    className="lg:text-xl xl:text-2xl text-xl font-extrabold uppercase"
                                    style={{ textShadow: "1px 1px 2px #000000" }}
                                >
                                    {plan.youSave}
                                </p>
                            </div>
                        )}
                        {plan.discount && (
                            <div className="px-4 py-2 rounded-md text-lg font-bold shadow-lg flex items-center justify-start gap-2 bg-[#DE3C3E] text-white">
                                <img
                                    src="https://sinoclear.net/pm/images/check-mark@2x.webp"
                                    className="h-8 w-8"
                                />
                                <p
                                    className="lg:text-xl xl:text-2xl text-xl font-extrabold uppercase"
                                    style={{ textShadow: "1px 1px 2px #000000" }}
                                >
                                    {plan.discount}
                                </p>
                            </div>
                        )}

                        {plan.freeshipping && plan.leastpopular && (
                            <div className="px-4 py-2 mb-12 rounded-md text-lg font-bold shadow-lg flex items-center justify-start gap-2 bg-[#146E54] text-white">
                                <img
                                    src="https://sinoclear.net/pm/images/check-mark@2x.webp"
                                    className="h-8 w-8"
                                />
                                <p
                                    className="lg:text-xl xl:text-2xl text-xl font-extrabold uppercase"
                                    style={{ textShadow: "1px 1px 2px #000000" }}
                                >
                                    {plan.freeshipping}
                                </p>
                            </div>
                        )}
                        {plan.freeshipping && !plan.leastpopular && (
                            <div className="px-4 py-2 rounded-md text-lg font-bold shadow-lg flex items-center justify-start gap-2 bg-[#146E54] text-white">
                                <img
                                    src="https://sinoclear.net/pm/images/check-mark@2x.webp"
                                    className="h-8 w-8"
                                />
                                <p
                                    className="lg:text-xl xl:text-2xl text-xl font-extrabold uppercase"
                                    style={{ textShadow: "1px 1px 2px #000000" }}
                                >
                                    {plan.freeshipping}
                                </p>
                            </div>
                        )}

                        {plan.bonuses && (
                            <div className="px-4 py-2 rounded-md text-lg font-bold shadow-lg flex items-center justify-start gap-2 bg-[#0A203C] text-white">
                                <img
                                    src="https://sinoclear.net/pm/images/check-mark@2x.webp"
                                    className="h-8 w-8"
                                />
                                <p
                                    className="lg:text-xl xl:text-2xl text-xl font-extrabold uppercase"
                                    style={{ textShadow: "1px 1px 2px #000000" }}
                                >
                                    {plan.bonuses}
                                </p>
                            </div>
                        )}
                        {plan.gurantee && (
                            <div className="px-4 py-2 rounded-md text-lg font-bold shadow-lg flex items-center justify-start gap-2 bg-[#0090E1] text-white">
                                <img
                                    src="https://sinoclear.net/pm/images/check-mark@2x.webp"
                                    className="h-8 w-8"
                                />
                                <p
                                    className="lg:text-xl xl:text-2xl text-xl font-extrabold uppercase"
                                    style={{ textShadow: "1px 1px 2px #000000" }}
                                >
                                    {plan.gurantee}
                                </p>
                            </div>
                        )}
                    </div>
                </div>

                {/* Order Button */}
                {/* <div className="bg-[url('https://sinoclear.net/pm/images/CTA-new.png')] bg-no-repeat bg-center bg-contain h-24 flex items-center justify-center text-center text-xs">
                    <a
                        href={plan.buttonLink}
                        className="-ml-5 font-bold pr-3 pb-1 text-[25px]"
                    >
                        ORDER NOW
                    </a>
                </div> */}

                <div className=" flex items-center justify-center text-center text-xs pt-2">
                    {/* <span
                        className="cursor-pointer"

                        onClick={() => {
                            const alreadyDisplayedKey = `alreadyElsDisplayed${SECONDS_TO_DISPLAY}`;
                            const alreadyElsDisplayed =
                                localStorage.getItem(alreadyDisplayedKey);

                            if (alreadyElsDisplayed)
                                localStorage.removeItem(alreadyDisplayedKey);
                            window.open(plan.buttonLink, "_self");
                        }}
                    >
                        <img src={button} />
                    </span> */}


                      
<a
  id="cta-button"
  className="cursor-pointer"
  href={`${plan.buttonLink}${vid ? `&tid=${vid}` : ""}`}
  onClick={(e) => {
    const alreadyDisplayedKey = `alreadyElsDisplayed${SECONDS_TO_DISPLAY}`;
    const alreadyElsDisplayed = localStorage.getItem(alreadyDisplayedKey);

    if (alreadyElsDisplayed) {
      localStorage.removeItem(alreadyDisplayedKey);
    }

    // optional: log or override redirect
    const url = `${plan.buttonLink}${vid ? `&tid=${vid}` : ""}`;
    console.log(url);

    // let it go to href naturally — OR uncomment this to force it:
    // window.location.href = url;
  }}
>
  <img src={button} alt="CTA Button" />
</a>
               
                </div>

                <div className="flex items-center justify-center gap-2 bg-white rounded-md px-4 py-2 shadow-md w-fit mx-auto ">
                    <div className="flex items-center justify-center gap-5">
                        <img src="https://cdn1.breatheagain.io/media/vsl/paymentmethod.webp" />
                    </div>
                </div>

                {/* Pricing */}

                <div className="block text-center mt-6 pb-2">
                    <span className="line-through text-[#132c4d] decoration-red-600 font-semibold text-[26px]">
                        {" "}
                        ${plan.originalPrice}
                    </span>

                    <span className="text-[#132c4d] font-extrabold text-[29px] pl-3">
                        ${plan.discountedPrice}
                    </span>
                </div>
            </div>
        </div>
    );
}

const PricingCards = ({ heading, startTimer, isVsl = false }) => {
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [timeLeft, setTimeLeft] = useState(15 * 60); // 15 minutes in seconds
    const [vid, setVid] = useState("");

    useEffect(() => {
      if (window?.clickmagick_cmc?.vid) {
        setVid(window.clickmagick_cmc.vid);
      }
    }, []);
  


    useEffect(() => {
        if (!startTimer) return;

        const timerInterval = setInterval(() => {
            setTimeLeft((prev) => (prev > 0 ? prev - 1 : 0));
        }, 1000);

        return () => clearInterval(timerInterval); // Cleanup
    }, [startTimer]);

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(
            2,
            "0"
        )}`;
    };

    return (
        <>
            <div className="bg-color-offer offer-bg ">
                <div className=" mx-auto  md:px-6 px-4 py-8 max-w-7xl md:mt-10 pt-20">
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
                        {pricingData.map((plan, index) => (
                            <PricingCard
                                key={index}
                                plan={plan}
                                isMiddle={index === 1}
                                isThird={index === 2}
                                isVsl={isVsl}
                                vid={vid} // 👈 Pass vid to PricingCard
                            />
                        ))}
                    </div>
                </div>
                <div className="flex flex-col gap-5 py-14 max-w-6xl p-2 mx-auto relative z-10">
                    <div className="flex  flex-row items-center md:px-6 px-3">
                        <img
                            src="https://sinoclear.net/pm/images-nw/contact-us.svg"
                            className="w-24 h-auto"
                        />
                        <p className="text-white md:text-[24px] text-[18px]  font-light md:leading-[30px] leading-[20px]">
                            If you are not happy with your purchase for any reason, contact us
                            anytime, and we’ll refund every penny of your investment. You
                            don’t even have to send the bottles back.
                        </p>
                    </div>
                    <div
                        onClick={() => setIsOpenModal(true)}
                        className="text-white cursor-pointer md:text-[24px] text-[24px] text-center md:text-start underline font-light md:px-0 px-3"
                    >
                        <span>
                            <strong className="font-bold"> No Thanks</strong>, I understand
                            that I will never see this offer again. I’d rather pay full price
                            later. Take me to the next page.
                        </span>
                    </div>
                    {/* Modal */}
                    {isOpenModal && (
                        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center p-0 justify-center z-50">
                            <div className="bg-white overflow-auto w-full h-full relative  ">
                                {/* Content Section */}
                                <div className="space-y-5 pt-5 w-full flex items-center justify-center flex-col min-h-screen  ">
                                    <div className="max-w-7xl mx-auto">
                                        <div className="flex max-w-7xl mx-auto items-center justify-between sm:flex-row flex-col">
                                            <div className="flex items-center gap-2">
                                                <img src={madeUsa} className="w-24" />
                                                <img src={FdaImg} className="w-24 sm:hidden block" />
                                            </div>
                                            <div className="space-y-3 text-center">
                                                <h2 className=" lg:text-5xl md:text-4xl text-2xl font-bold">
                                                    Last Chance!
                                                </h2>
                                                <h2 className="xl:text-5xl lg:text-4xl md:text-3xl text-xl font-bold text-[#ed1a3b]">
                                                    Add 2 Bottles + Get 4 FREE!
                                                </h2>
                                            </div>
                                            <img src={FdaImg} className="w-24 sm:block hidden" />
                                        </div>
                                        <div className="space-y-2 flex flex-col justify-center items-center">
                                            <img
                                                src={NoOfferImg}
                                                className="w-full lg:w-[510px] md:w-80"
                                            />
                                            <p className=" mb-2 md:text-3xl text-lg text-[#333333] font-bold">
                                                {isVsl && (
                                                    <span className="line-through decoration-red-500">
                                                        Regular Price $594
                                                    </span>
                                                )}

                                                {/* {" "} Your Price: $118.00 */}
                                            </p>
                                            <h4 className="md:text-5xl text-3xl text-[#132c4d] font-bold mb-1 text-center">
                                                Buy 2 + Get 4 FREE
                                            </h4>
                                            <p className="text-gray-900 font-semibold md:text-3xl text-xl mb-2">
                                                FOR JUST
                                            </p>
                                            <p className="md:text-5xl text-3xl pb-3 font-bold">
                                                $118.
                                                <span className="text-lg text-black">00</span>
                                            </p>

                                            {/* Button */}
                                            <div className="flex flex-col gap-3 ">
                                                <a
                                                    href="https://scalerespo.pay.clickbank.net/?cbitems=10&cbur=a"
                                                    className="w-full bg-[#fbc719] hover:bg-[#C59704] text-black shadow-lg font-black md:px-14 md:py-8 p-4 uppercase underline px-14 rounded-[45px] md:text-2xl text-xl  text-center transition-colors duration-100 ease-in-out shadow-[0 4px 0 0 #d1a615, 0 8px 0 0 #00000012]"
                                                >
                                                    Yes! Upgrade My Order
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="bg-gray-100 w-full p-4">
                                        <div className=" max-w-6xl mx-auto">
                                            <div className="flex sm:flex-row flex-col items-center gap-2 mb-3">
                                                <img src={ContactDark} className="w-24 h-24" />
                                                <p className="text-black text-lg font-light">
                                                    If you are not happy with your purchase for any
                                                    reason, contact us anytime, and we’ll refund every
                                                    penny of your investment. You don’t even have to send
                                                    the bottles back.
                                                </p>
                                            </div>
                                            <a
                                                href=" https://scalerespo.pay.clickbank.net/?cbitems=4&cbur=d"
                                                className="hover:text-black text-start text-[#444444] cursor-pointer text-lg underline mt-5 font-light"
                                            >
                                                <p>
                                                    <strong className="font-bold">No Thanks</strong>, I
                                                    understand that I will never see this offer again. I’d
                                                    rather pay full price later. Take me to the next page.
                                                </p>
                                            </a>

                                            <div className="w-full pt-10 text-start text-xs text-black space-y-4 font-light">
                                                <p>
                                                    ClickBank is the retailer of this product. CLICKBANK®
                                                    is a registered trademark of Click Sales, Inc., a
                                                    Delaware corporation located at 1444 S. Entertainment
                                                    Ave., Suite 410 Boise, ID 83709, USA and used by
                                                    permission. ClickBank’s role as retailer does not
                                                    constitute an endorsement, approval or review of this
                                                    product or any claim, statement or opinion used in
                                                    promotion of this product.
                                                </p>
                                                <p>
                                                    Statements on this website have not been evaluated by
                                                    the Food and Drug Administration. Products are not
                                                    intended to diagnose, treat, cure or prevent any
                                                    disease. If you are pregnant, nursing, taking
                                                    medication, or have a medical condition, consult your
                                                    physician before using our products.
                                                </p>
                                                <p>
                                                    Testimonials, case studies, and examples found on this
                                                    page are results that have been forwarded to us by
                                                    users of RespoClear and related products are not
                                                    intended to represent or guarantee that anyone will
                                                    achieve the same or similar results.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

export default PricingCards;
